var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-loudspeaker-mono"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3878 1.61244L4.52627 5.65269H2.19077C1.76327 5.65269 1.41602 5.99994 1.41602 6.42744V11.5724C1.41602 11.9999 1.76327 12.3472 2.19077 12.3472H4.52627L12.3878 16.3874C12.5021 16.4462 12.6297 16.4746 12.7582 16.4698C12.8866 16.4651 13.0118 16.4274 13.1215 16.3604C13.2312 16.2934 13.3219 16.1993 13.3847 16.0871C13.4476 15.9749 13.4806 15.8485 13.4805 15.7199V2.27994C13.4806 2.15137 13.4476 2.02494 13.3847 1.91278C13.3219 1.80063 13.2312 1.70653 13.1215 1.6395C13.0118 1.57248 12.8866 1.53479 12.7582 1.53005C12.6297 1.52531 12.5021 1.55368 12.3878 1.61244ZM15.927 6.87519H14.46V11.1247H15.9263C16.4693 11.1247 16.9088 10.6844 16.9088 10.1414V7.85919C16.9088 7.31544 16.4693 6.87519 15.9263 6.87519",
    fill: "#989BA2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuNotice);
export default __webpack_public_path__ + "static/media/icon_menu_notice.ffc3d8519e986517633e2e73749d41a0.svg";
export { ForwardRef as ReactComponent };